module.exports = __webpack_public_path__ + "public/images/icons/belarus.e67ea2e2cd299f48e8175808cb5499f6.png";